import { put, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

function* partnerQaQuestionListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/partnerQaQuestionApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      action.callback(res.data);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* partnerQaQusetionAnswerAdd(action) {
  yield put(loadingSet(true));

  const {res, err} = yield call( function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'add');
    params.append('qaId', payload.qaId);
    params.append('qaAnswerOpen', payload.answerOpen);
    params.append('qaAnswerText', payload.answerText);
    return axios.post(config.apiUri + "member/partnerQaQuestionAnswerEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "COMMUNITY_QA_ANSWER_SET",
        payload: {
          qaId: action.payload.qaId,
          answerText: action.payload.answerText,
        },
      });
      yield put({
        type: "TIMELINE_QA_QUESTION_ANSWER_SET",
        payload: {
          qaId: action.payload.qaId,
          answerText: action.payload.answerText,
        },
      });
      action.callback(res.data);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* partnerQaQusetionAnswerDel(action) {
  yield put(loadingSet(true));

  const res = yield call( function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('pic', payload.pic);
    params.append('qaId', payload.qaId);
    return axios.post(config.apiUri + "member/partnerQaQuestionAnswerEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "COMMUNITY_QA_ANSWER_SET",
        payload: {
          qaId: action.payload.qaId,
          answerText: null,
        },
      });
      yield put({
        type: "MY_QA_ANSWER_ITEM_SET",
        payload: {
          type: 'del',
          qaId: action.payload.qaId,
        },
      });
      yield put({
        type: "TIMELINE_QA_QUESTION_ANSWER_SET",
        payload: {
          qaId: action.payload.qaId,
          answerText: null,
        },
      });
      action.callback(res.data);
    }
  }
  yield put(loadingSet(false));
}

function* partnerQaAnswerListGet(action) {
  yield put(loadingSet(true));

  const res = yield call( function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/partnerQaAnswerApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      action.callback(res.data);
    }
  }

  yield put(loadingSet(false));
}


const saga = [
  takeLatest('PARTNER_QA_QUESTION_LIST_GET', partnerQaQuestionListGet),
  takeLatest('PARTNER_QA_QUESTION_ANSWER_ADD', partnerQaQusetionAnswerAdd),
  takeLatest('PARTNER_QA_QUESTION_ANSWER_DEL', partnerQaQusetionAnswerDel),
  takeLatest('PARTNER_QA_ANSWER_LIST_GET', partnerQaAnswerListGet),
];

export default saga;
